export default "__VITE_ASSET__Do1q5Wk1__"